module.exports = __webpack_public_path__ + "fonts/fa-solid-900.55071ae1.woff2";